
export default {
	$newFashion: true,
	getInvoiceDetail: {
		success(state: any, response: any){
			console.log(state, response, 'success');
			state.invoiceDetail = response.data.data
		},
		fail(state: any, response: any){
			console.log(response, 'fail');
		}
	}
}